import { render } from "./Orthopaedics.vue?vue&type=template&id=338aaa09"
import script from "./Orthopaedics.vue?vue&type=script&lang=ts"
export * from "./Orthopaedics.vue?vue&type=script&lang=ts"
script.render = render

export default script